'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.collectionBackdrop = document.querySelector(
      '[data-collection-filter-close]'
    );
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClose = this.onClose.bind(this);
    this.addEventListener('click', this.onOpen.bind(this), false);
    this.collectionBackdrop?.addEventListener('click', this.onClose, false);
  }
  disconnectedCallback() {
    this.collectionBackdrop?.removeEventListener('click', this.onClose, false);
    document.removeEventListener('keydown', this.onKeyDown);
  }
  onOpen() {
    if (this.classList.contains('open')) {
      this.onClose();
      return;
    }

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty(
        'padding-right',
        `${scrollbarWidth}px`
      );
    }
    this.collectionSidebar?.classList.add('open');
    this.collectionSidebar?.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('open-drawer', 'open-sidebar');
    this.classList.add('open');
    this.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', this.onKeyDown);
  }
  onClose() {
    this.collectionSidebar?.classList.remove('open');
    this.collectionSidebar?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.documentElement.style.removeProperty('padding-right');
    this.classList.remove('open');
    this.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', this.onKeyDown);
  }
  onKeyDown(event) {
    if (event.key === 'Escape') this.onClose();
  }
}
customElements.define('btn-filter', BtnFilter);

if (!window.chilliCollectionFilterBackdropBound) {
  window.chilliCollectionFilterBackdropBound = true;
  document.addEventListener(
    'click',
    (event) => {
      const backdrop = event.target.closest?.('[data-collection-filter-close]');
      if (!backdrop) return;
      event.preventDefault();
      event.stopPropagation();
      const filterButton = document.querySelector(
        'btn-filter.open, btn-filter[aria-expanded="true"]'
      );
      if (filterButton && typeof filterButton.onClose === 'function') {
        filterButton.onClose();
        return;
      }
      document.getElementById('CollectionSidebar')?.classList.remove('open');
      document.getElementById('CollectionSidebar')?.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      document.documentElement.style.removeProperty('padding-right');
      document.querySelectorAll('btn-filter').forEach((button) => {
        button.classList.remove('open');
        button.setAttribute('aria-expanded', 'false');
      });
    },
    true
  );
}

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    const filterButton = document.querySelector('btn-filter');
    if (filterButton && typeof filterButton.onClose === 'function') {
      filterButton.onClose();
      return;
    }
    this.collectionSidebar?.classList.remove('open');
    this.collectionSidebar?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelectorAll('.btn-filter').forEach((button) => {
      button.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const sizeOption = this.querySelector('.swatch-option.size');
    const wasActive = sizeOption?.classList.contains('current-filter');
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    let url = this.getAttribute('data-href');
    if (sizeOption && !wasActive) {
      const filterUrl = new URL(url, window.location.origin);
      if (!filterUrl.searchParams.has('filter.v.availability')) {
        filterUrl.searchParams.set('filter.v.availability', '1');
      }
      url = `${filterUrl.pathname}${filterUrl.search}`;
    }
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute('name');
              const nameMax = maxPrice.getAttribute('name');
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace('?', '') + '&' + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (window.innerWidth <= 1024) {
            const collectionFilterBlocks = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.collectionFilterBlocks);
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.productgridcontainer);
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains('open')
            ) {
              document.querySelector(options_collection.collectionSidebar).classList.remove('open')
            }
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
          }
          document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
          const activeFilterButton = document.querySelector('btn-filter');
          if (activeFilterButton && typeof activeFilterButton.onClose === 'function') {
            activeFilterButton.onClose();
          }
          const sectionElement = document.querySelector(
            '#productgridcontainer'
          );
          
          if (sectionElement) {
            const elementPosition = sectionElement.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset;
            const extraOffset = 100;
            const scrollToPosition =
              elementPosition + offsetPosition - extraOffset;
            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth',
            });
          }
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          const motionCollection = document.querySelector(".motion-collection");
          if (motionCollection) {
            motionCollection.reloadAnimationEffect();
          }
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
        });
      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, '', urlUpdate);
      } else {
        window.history.pushState({ url: url }, '', url);
      }
    },
  };
})();
eventCollectionShopify.init();

if (!customElements.get('chilli-size-results')) {
  customElements.define('chilli-size-results', class extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('#productgridcontainer');
      if (!this.container) return;
      const decodeFormat = value => new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;
      const countFormat = decodeFormat(this.dataset.countFormat);
      const progressFormat = decodeFormat(this.dataset.progressFormat);
      this.pending = false;
      this.sync = () => {
        const grid = this.container.querySelector('#product-grid');
        if (!grid || !this.isConnected) return;
        const excluded = new Set(
          [...grid.querySelectorAll('[data-size-excluded]')].map(item => item.dataset.sizeExcluded)
        ).size;
        if (!excluded) return;
        const total = Math.max(0, Number(this.dataset.total) - excluded);
        const toolbar = this.container.querySelector('#toolbar-amount');
        const countText = countFormat.replaceAll('__COUNT__', String(total));
        if (toolbar && toolbar.textContent.trim() !== countText.trim()) toolbar.textContent = countText;
        const progress = this.container.querySelector('.loadmore-amount');
        const amount = grid.querySelectorAll('.grid__item:not([data-size-excluded])').length;
        const progressText = progressFormat
          .replaceAll('__AMOUNT__', String(Math.min(amount, total)))
          .replaceAll('__COUNT__', String(total));
        if (progress && progress.textContent.trim() !== progressText.trim()) progress.textContent = progressText;
      };
      this.observer = new MutationObserver(() => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          this.sync();
        });
      });
      this.observer.observe(this.container, {childList: true, subtree: true});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}



// Counts use the same Shopify facets and available-size check as the product grid.
if (!customElements.get('chilli-availability-counts')) {
  const countRequests = new Map();
  customElements.define('chilli-availability-counts', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.updateCounts());
    }
    async updateCounts() {
      const url = new URL(this.dataset.url, location.origin);
      url.search = location.search;
      url.searchParams.delete('filter.v.availability');
      url.searchParams.delete('page');
      url.searchParams.delete('view');
      url.searchParams.set('section_id', 'chilli-filter-counts');
      const key = url.href;
      if (!countRequests.has(key)) {
        const request = (async () => {
          const totals = {available: 0, unavailable: 0};
          let next = url;
          const visited = new Set();
          while (next && !visited.has(next.href)) {
            visited.add(next.href);
            const response = await fetch(next);
            if (!response.ok) throw new Error('Inventory count request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = doc.querySelector('[data-chilli-availability]');
            if (!data) throw new Error('Inventory count response missing');
            const page = JSON.parse(data.textContent);
            totals.available += Number(page.available);
            totals.unavailable += Number(page.unavailable);
            next = page.next ? new URL(page.next, location.origin) : null;
            if (next) next.searchParams.set('section_id', 'chilli-filter-counts');
          }
          return totals;
        })();
        countRequests.set(key, request);
        request.catch(() => countRequests.delete(key));
      }
      try {
        const counts = await countRequests.get(key);
        if (!this.isConnected) return;
        const sidebar = this.closest('#CollectionSidebar');
        for (const [value, count] of [['1', counts.available], ['0', counts.unavailable]]) {
          const node = sidebar.querySelector('[data-availability-count="' + value + '"]');
          if (!node) continue;
          node.textContent = '(' + count + ')';
          const row = node.closest('li');
          if (row && !row.classList.contains('current-filter')) {
            row.classList.toggle('disabled', count === 0);
            row.classList.toggle('pointer-none', count === 0);
            row.classList.toggle('light-dark-grey', count === 0);
          }
        }
      } catch (error) {
        // Native counts remain available if the optional request is interrupted.
      }
    }
  });
}
